<template>
  <div>
  <Table class="display nowrap" style="width:100%;padding-left:10px;">
    <thead>
        <tr>
            <th>Produit</th>
            <th>Nbre de jours</th>
            <th>Statut</th>
            <th>Action</th>
        </tr>
    </thead>
     <tbody>
        <tr v-for="item in product">
          <td>{{ item.name }}</td>
          <td>{{ item.diff }}</td>
          <td v-if="item.product_conso<item.days">
                <span class="badge bg-warning ">Fini</span>
          </td>
          <td v-else>
<span class="badge text-success bg-success ">En cours</span>
          </td>
          <td>
          <i onMouseOver="this.style.cursor='pointer'" @click="ressort(item)" class="fa fa-trash"></i>

          <span onMouseOver="this.style.cursor='pointer'" @click="addToCard(item)" class="material-icons-outlined text-warning" title="Créer une vente pour ce produit">
            add_shopping_cart
        </span>

          </td>
        </tr>
    </tbody>
</Table>
  </div>
</template>

<script>
import { sync, get } from 'vuex-pathify'
import ApiManager from '../_core/ApiManager'

export default {
    props: ['order'],
    mounted() {
     this.getproductByUser(this.order.user_id)
     this.getUser(this.order.user_id)
     this.getOrder(this.order.id)
     },
    data: () => {
        return {
            product: [],
            user_id: 0,
            order_id: 0
        }
    },
      methods: {
        async getproductByUser(user_id)
        {
        await ApiManager.loadProductById(user_id).then(res => {
        this.product = res
      })
        },
      async ressort(item)
      {
              await ApiManager.ressort(item.id).then(() => {})
              this.getproductByUser(this.user_id)
      },
      async addToCard(item)
      {
        await ApiManager.addToCardByOrder(item.product_id,this.user_id,this.order_id).then((res) => {
        if(res.status)
        {
        return location.href='caisse?order='+res.order_id
        }
        })
      },
      getUser(user_id)
      {
      return this.user_id=user_id;
      },
       getOrder(order_id)
      {
      return this.order_id=order_id;
      }

    }
}
</script>
